module.exports = __webpack_public_path__ + "img/SHPIcon.32e24bef.jpeg";